import { createContext, useContext, useMemo } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const queryClient = useQueryClient();
  const me = useQuery({
    queryKey: ["me"],
    queryFn: async () => (await api.get("/auth/me")).data.user,
    staleTime: 5 * 60_000,
  });
  const config = useQuery({ queryKey: ["config"], queryFn: async () => (await api.get("/config")).data, staleTime: Infinity });

  const value = useMemo(() => {
    const user = me.data || null;
    return {
      user,
      loading: me.isLoading,
      isAuthed: !!user,
      isAdmin: user?.role === "admin",
      config: config.data,
      refreshAll: () => queryClient.invalidateQueries(),
      logout: async () => {
        await api.post("/auth/logout");
        queryClient.clear();
        window.location.href = "/";
      },
    };
  }, [me.data, me.isLoading, config.data, queryClient]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
export const useAuthFeatures = () => useContext(AuthContext).config?.features || {};
